import React from 'react';
import PropTypes from 'prop-types';
import { MeteringPointEdit } from '../../containers';
import { Layout } from 'antd';

const MeteringPoint = ({
  match: {
    params: { meteringPointId, tabKey },
  },
  location,
}) => {
  const searchParams = new URLSearchParams(location.search);
  const fromProductionUnitId = searchParams.get('puId');

  return (
    <Layout className="main-container">
      <MeteringPointEdit
        meteringPointId={meteringPointId}
        tabKey={tabKey}
        fromProductionUnitId={fromProductionUnitId}
      />
    </Layout>
  );
};

MeteringPoint.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      meteringPointId: PropTypes.string.isRequired,
      tabKey: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default MeteringPoint;
